import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useErrorHandler } from "react-error-boundary";
import axios from "axios";
import Table from "../../../../Shared/Table";
import LoadingScreen from "../../../../Shared/LoadingScreen";
import LoadMoreItems from "../../../../Shared/LoadMoreItemsScreen";
const Orders = () => {
  const { id } = useParams();
  const handleError = useErrorHandler();
  const [isLoading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [lastEvaulatedKey, setLastEvaluatedKey] = useState({
    lastEvaluatedKey: null,
    limit: "50",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handleOrders();
    return () => {
      setOrders([]);
      setIsLoaded(false);
    };
  }, []);

  const handleOrders = async () => {
    if (!isLoaded) {
      setLoading(true);
    } else {
      setLoadMore(true);
    }
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}restaurant/orders/${id}`,
        {
          ...lastEvaulatedKey,
        }
      );
      if (res) {
        let temp = [];
        res.data.orders.map((order, i) => {
          temp.push(order);
          temp[i]["cart_total"] = order?.cartData?.Cart?.cart_total;
          temp[i]["created_at"] = new Date(order.created_at).toUTCString();
          temp[i]["service_time"] = order.service_time;
        });

        setLastEvaluatedKey({
          ...lastEvaulatedKey,
          lastEvaluatedKey: res.data.lastEvaluatedKey,
        });
        let arr = [...orders, ...res.data.orders];
        arr.sort((a, b) => {
          return b.readable_id - a.readable_id;
        });
        setOrders([...arr]);
      } else {
        handleError("Something went wrong!");
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
      setIsLoaded(true);
      setLoadMore(false);
    }
  };

  const formatData = (data) => {
    let formattedData = data.map((item, index) => ({
      orderId: item?.readable_id ? item.readable_id : "-",
      restOrderId: item?.restaurant_readable_id || "-",
      scanOrderId: item?.scan_order_id || "-",
      orderType: item.service_type ? item.service_type : "-",
      kind: item.kind ? item.kind : "-",
      total: "$" + item.cart_total,
      orderTime: item.created_at ? item.created_at : "-",

      serviceTime:
        item.service_time === "ASAP"
          ? "ASAP"
          : new Date(item.service_time).toUTCString().replace(/ GMT/g, ""),
      mobNumber: item.mobile_no ? item.mobile_no : "-",
      name: item.name ? item.name : "-",
      orderStatus: item.state ? item.state : "",
    }));
    return formattedData;
  };

  const columns = [
    {
      name: "orderId",
      label: "Global Order Id",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "restOrderId",
      label: "Restaurant Order Id",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "scanOrderId",
      label: "Scan Order Id",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "orderType",
      label: "Order Type",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "kind",
      label: "Kind",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "total",
      label: "Total",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "orderTime",
      label: "Order Time",
      options: {
        sort: true,
        filter: true,
      },
    },

    {
      name: "serviceTime",
      label: "Service Time",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "mobNumber",
      label: "Mob. Number",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "orderStatus",
      label: "Order Status",
      options: {
        sort: true,
        filter: true,
      },
    },
  ];
  const onTableChangeHandler = (action, tableState) => {
    const { page, rowsPerPage, data } = tableState;
    let diff = Math.abs(page * rowsPerPage - data.length);
    if (
      diff <= rowsPerPage &&
      lastEvaulatedKey.lastEvaluatedKey !== null &&
      (action === "changePage" || action === "changeRowsPerPage")
    ) {
      handleOrders();
      return;
    }
  };
  return (
    <>
      {isLoading ? (
        <LoadingScreen loading={isLoading} />
      ) : (
        <>
          {loadMore && <LoadMoreItems loading={loadMore} />}
          <Table
            data={formatData(orders)}
            columns={columns}
            title="Orders"
            onTableChange={onTableChangeHandler}
          />
        </>
      )}
    </>
  );
};
export default Orders;
